<template>
  <div id="ag-grid-demo">
    <div class="body">
      <vx-card>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-row>
              <table>
                <tr>
                  <td>
                    <DatePicker
                      size="small"
                      style="width: 150px"
                      :shortcuts="shortcuts"
                      :format="$formatDate"
                      :value="tglAwal"
                      type="date"
                      placeholder="Select date"
                      v-model="tglAwal"
                      @change="cekTanggal()"
                    ></DatePicker>
                  </td>
                  &nbsp;
                  <td>~</td>
                  &nbsp;
                  <td>
                    <DatePicker
                      size="small"
                      style="width: 150px"
                      :shortcuts="shortcuts"
                      :format="$formatDate"
                      :value="tglAkhir"
                      type="date"
                      placeholder="Select date"
                      v-model="tglAkhir"
                      @change="cekTanggal()"
                    ></DatePicker>
                  </td>

                  <td></td>
                </tr>
              </table>

              <vs-col
                vs-offset="1"
                vs-type="flex"
                vs-justify="left"
                vs-align="left"
                vs-w="10"
              >
              </vs-col>
            </vs-row>
          </div>
        </div>

        <el-tabs>
          <el-tab-pane :label="$t('detailList')">
            <el-row>
              <el-col :span="24">
                <div style="height: 90vh">
                  <vxe-table
                    size="mini"
                    :loading="loadingTable"
                    empty-text="Empty Data "
                    keep-source
                    border
                    show-footer
                    :footer-method="footerMethod"
                    ref="tableDetail"
                    height="90%"
                    row-key
                    highlight-hover-row
                    highlight-current-row
                    :row-config="{ isCurrent: true, isHover: true, height: 35 }"
                    :column-config="{ resizable: true }"
                    :data="contacts"
                    :mouse-config="{ selected: true }"
                    :checkbox-config="{
                      highlight: true,
                      range: true,
                    }"
                    :keyboard-config="{
                      isArrow: true,
                      isDel: true,
                      isEnter: true,
                      isTab: true,
                      isEdit: true,
                    }"
                    :edit-config="{
                      trigger: 'dblclick',
                      mode: 'cell',
                      showStatus: true,
                    }"
                    :scroll-y="{ mode: 'wheel' }"
                  >
                    <vxe-column type="seq" fixed="left" width="60"></vxe-column>

                    <vxe-column
                      width="150"
                      align="left"
                      header-align="center"
                      field="status"
                      :title="$t('status').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="250"
                      align="left"
                      header-align="center"
                      field="keteranganReject"
                      :title="$t('keteranganReject').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="left"
                      header-align="center"
                      field="noReg"
                      :title="$t('noRegi').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="center"
                      field="tanggal"
                      :title="$t('tanggal').toUpperCase()"
                      :formatter="$$formatDate"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="center"
                      field="tglEstimasi"
                      :title="$t('expiredDate').toUpperCase()"
                      :formatter="$$formatDate"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>

                    <vxe-column
                      width="120"
                      align="left"
                      header-align="center"
                      field="kodeBarang"
                      :title="$t('code').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="200"
                      align="left"
                      header-align="center"
                      field="namaBarang"
                      :title="$t('deskripsi').toUpperCase()"
                    >
                    </vxe-column>

                    <vxe-column
                      width="100"
                      align="center"
                      header-align="center"
                      field="satuan"
                      :title="$t('satuan').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="center"
                      header-align="center"
                      field="kategori"
                      :title="$t('kategori').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="left"
                      field="style"
                      :title="$store.state.styleName"
                      v-if="$store.state.availableStyle"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="left"
                      field="color"
                      :title="$store.state.colorName"
                      v-if="$store.state.availableColor"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="left"
                      field="size"
                      :title="$store.state.sizeName"
                      v-if="$store.state.availableSize"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="100"
                      align="center"
                      header-align="center"
                      field="spec"
                      :title="$store.state.specName"
                      v-if="$store.state.availableSpec"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>

                    <vxe-column
                      width="150"
                      align="right"
                      header-align="center"
                      field="qty"
                      :formatter="$$formatAmountBc"
                      :title="$t('qty').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>

                    <vxe-column
                      width="180"
                      align="right"
                      header-align="center"
                      field="qtyUse"
                      :formatter="$$formatAmountBc"
                      :title="$t('qtyPurchase').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>

                    <vxe-column
                      width="150"
                      align="left"
                      field="keterangan"
                      :title="$t('remark').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="left"
                      field="pic"
                      :title="$t('pic').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                    <vxe-column
                      width="150"
                      align="left"
                      field="user"
                      :title="$t('userInput').toUpperCase()"
                      sortable
                      :filters="[{ data: '' }]"
                      :filter-method="$$filterHeaderTable"
                    >
                      <template #filter="{ $panel, column }">
                        <input
                          type="type"
                          v-for="(option, index) in column.filters"
                          :key="index"
                          style="padding: 5px"
                          v-model="option.data"
                          @input="
                            $panel.changeOption($event, !!option.data, option)
                          "
                        />
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </vx-card>
    </div>
    <sweet-modal ref="modalDetail" width="80%">
      <el-row class="mt-5">
        <el-col :span="24"
          ><div>
            <el-descriptions
              title="DETAIL PURCHASE ORDER"
              class="margin-top margin-bot mb-5"
              :column="3"
              size="medium"
              border
            >
              <template slot="extra">
                <el-button type="warning" size="small">EDIT</el-button>
              </template>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-s-order"></i>
                  PO NUMBER
                </template>
                {{ detail.noPo }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-date"></i>
                  PO DATE
                </template>
                {{ detail.tanggal != null ? detail.tanggal.slice(2, 10) : "" }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-info"></i>
                  STATUS
                </template>
                <el-tag
                  size="small"
                  :type="
                    detail.status == 'New'
                      ? 'primary'
                      : detail.status == 'On Process'
                      ? 'warning'
                      : detail.status == 'Close'
                      ? 'Success'
                      : ''
                  "
                  >{{ detail.status }}</el-tag
                >
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  USER INPUT
                </template>
                <p>{{ detail.user }}</p>
              </el-descriptions-item>
            </el-descriptions>
          </div></el-col
        >
      </el-row>
      <vs-divider position="left"></vs-divider>
      <el-row>
        <el-col :span="24"
          ><div>
            <vxe-table
              :loading="loadingTable"
              empty-text="Empty Data "
              keep-source
              border
              ref="tableDetail"
              height="350"
              size="mini"
              row-key
              highlight-hover-row
              highlight-current-row
              :row-config="{ isCurrent: true, isHover: true, height: 25 }"
              :column-config="{ resizable: true }"
              :data="detail.listDetail"
              :mouse-config="{ selected: true }"
              :checkbox-config="{
                highlight: true,
                range: true,
              }"
              :keyboard-config="{
                isArrow: true,
                isDel: true,
                isEnter: true,
                isTab: true,
                isEdit: true,
              }"
              :edit-config="{
                trigger: 'dblclick',
                mode: 'cell',
                showStatus: true,
              }"
              :scroll-y="{ mode: 'wheel' }"
            >
              <vxe-column type="seq" fixed="left" width="60"></vxe-column>

              <vxe-column
                width="120"
                align="left"
                fixed="left"
                header-align="center"
                field="kodeBarang"
                title="CODE"
              >
              </vxe-column>
              <vxe-column
                width="200"
                align="left"
                fixed="left"
                header-align="center"
                field="namaBarang"
                title="DESCRIPTION"
              >
              </vxe-column>

              <vxe-column
                width="100"
                align="center"
                header-align="center"
                field="satuan"
                title="UNIT"
              >
              </vxe-column>
              <vxe-column
                width="100"
                align="center"
                header-align="center"
                field="kategori"
                title="CATEGORY"
              >
              </vxe-column>
              <vxe-column
                width="100"
                align="center"
                header-align="center"
                field="spec"
                title="SPEC"
              >
              </vxe-column>
              <vxe-column
                width="100"
                align="center"
                header-align="center"
                field="currency"
                title="CURRENCY"
              >
              </vxe-column>

              <vxe-column
                width="150"
                align="right"
                header-align="center"
                field="qty"
                :formatter="$$formatAmountBc"
                title="QTY"
              >
              </vxe-column>
              <vxe-column
                width="150"
                align="right"
                header-align="center"
                field="qtyUse"
                :formatter="$$formatAmountBc"
                title="QTY IN"
              >
              </vxe-column>
              <vxe-column
                width="150"
                align="right"
                :formatter="$$formatAmountBc"
                field="price"
                header-align="center"
                title="PRICE"
              >
              </vxe-column>
              <vxe-column
                width="150"
                align="right"
                header-align="center"
                field="amount"
                title="AMOUNT"
                :formatter="$$formatAmountBc"
              >
              </vxe-column>
            </vxe-table></div
        ></el-col>
      </el-row>

      <vs-button
        class="mt-3"
        vs-align="right"
        vs-justify="right"
        v-on:click="$refs.modalDetail.close()"
      >
        Close
      </vs-button>
    </sweet-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";

import XLSX from "xlsx";
import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";
import "vue-ads-pagination/dist/vue-ads-pagination.css";
// import EditDialog from "./edit";

export default {
  components: {
    SweetModal,
    SweetModalTab,
    VueAdsPagination,
    VueAdsPageButton,
  },
  data() {
    return {
      detail: {},
      shortcuts: [
        {
          text: "Today",
          onClick() {
            const date = new Date();
            // return a Date
            return date;
          },
        },
        {
          text: "Yesterday",
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          },
        },
      ],
      virtualScrollOption: {
        // 是否开启
        enable: true,
      },
      // eventCustomOption: {
      //   bodyRowEvents: ({ row, rowIndex }) => {
      //     return {
      //       click: (event) => {
      //         const currentRowKey = row["rowKey"];
      //         this.changeSelectedRowKeyByRowClick(currentRowKey);
      //       },
      //     };
      //   },
      // },
      radioOption: {
        selectedRowKey: "",
        selectedRowChange: ({ row }) => {
          this.changeSelectedRowKey(row.rowKey);
        },
      },

      format: "yyyy-MM-dd",
      tglAwal: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      tglAkhir: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      tableData: [],
      totalItems: "",
      index: "",
      search: "",
      changeLimit: null,
      isNavOpen: false,
      selected: [],
      contacts: [],
      contactsAwal: [],
      contacts2: [],
      page: 0,
      getIdForEdit: "",
      start: "",
      end: "",
      loadingTable: false,
      selected: [],
      searchHeader: "",
      searchDetail: "",
      detailContact: [],
      detailContactAwal: [],
      dataDetail: [],
      getDataKomposisi: [],
      activeConfirm: false,
    };
  },
  watch: {
    searchHeader: function () {
      this.contacts = this.contactsAwal.filter(
        (f) =>
          f.label.toLowerCase().indexOf(this.searchHeader.toLowerCase()) > -1
      );
    },
    searchDetail: function () {
      this.detailContact = this.detailContactAwal.filter(
        (f) =>
          f.label.toLowerCase().indexOf(this.searchDetail.toLowerCase()) > -1
      );
    },
    page: function () {
      this.getData({
        changeLimit: this.contacts.size,
      });
    },
  },
  computed: {
    columnIndexWidth() {
      return this.columns.reduce((acc, cur) => acc + Number(cur.width), 0);
    },
  },
  methods: {
    footerMethod({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return "TOTAL";
          }
          if (
            [
              "qty",
              "qtyUse",
              "qtyGradeB",
              "qtyUseGradeB",
              "qtyGradeC",
              "qtyUseGradeC",
              "price",
              "amount",
            ].includes(column.property)
          ) {
            data.forEach((e) => {
              e.amount = e.qty * e.price;
            });
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    formatterNum({ cellValue }) {
      return this.$formatAngka(cellValue);
    },
    getDataSelected({ checked, records }) {
      // console.log(this.$refs.xTable.getCheckboxIndeterminateRecords(isFull));

      this.selected = records;
    },
    async getDetail(row) {
      this.dataDetail = row.listDetail;
      this.detail = row;

      this.$refs.modalDetail.open();
    },
    validateDeleteData() {
      let selected = this.$refs.xTable.getCheckboxRecords();
      if (selected.length <= 0) {
        return this.$notify({
          offset: 200,
          type: "warning",
          message: this.$t("silahkanPilihData"),
          title: "WARNING",
        });
      }
      for (const e of selected) {
        if (e.status.toLowerCase() != "new") {
          return this.$notify({
            offset: 200,
            type: "warning",
            message: "Status data has changed can not be deleted",
            title: "WARNING",
          });
        }
      }
      this.deleteData();
    },
    async deleteData() {
      this.loadingWait();
      let selected = this.$refs.xTable.getCheckboxRecords();
      for (const elm of selected) {
        let post = await this.$api.delete(
          "api/v1/purchasing/request/deleteall/" + elm.id
        );
      }

      this.$notify({
        offset: 200,
        title: "SUCCESS",
        message:
          this.$store.state.userLang == "id"
            ? "BERHASIL MENGHAPUS DATA"
            : "DELETED DATA SUCCESSFULLY",
        type: "success",
      });
      this.getData();
      this.loadingStop();
    },

    cekTanggal() {
      if (this.tglAwal > this.tglAkhir) {
        this.tglAwal = this.tglAkhir;
        this.$vs.notify({
          text: this.$t("silahkanPilihTanggalYangSesuai"),
          color: "warning",
        });
      } else {
        this.getData();
      }
    },
    async goToEdit() {
      let select = this.$refs.xTable.getCheckboxRecords();
      if (select.length <= 0) {
        return this.notifValidasi(this.$t("silahkanPilihData"), true);
      }
      if (select[0].status.toLowerCase() != "new") {
        return this.notifValidasi(
          this.$store.state.userLang == "id"
            ? "Data Sudah Berubah status tidak dapat di ubah"
            : "Data Already Changed status cannot be changeds",
          true
        );
      }
      // console.log(id);
      if (select.length > 0) {
        await this.$router.push({
          name: "purchasingrequestupdate",
          params: { id: select[0] },
        });
      }
    },
    pageChange(page) {
      this.page = page;
      // console.log(page);
    },

    rangeChange(start, end) {
      this.start = start;
      // console.log(start, end);
    },

    getIdToChild() {
      this.selected;
    },
    handleSelected(tr) {
      // console.log(this.changeLimit);
      this.$vs.notify({
        title: `Po Number: ${tr.noPo}`,
        text: `Code: ${tr.kodeMaterial}`,
      });
    },

    goToDelete(tr) {
      // console.log(this.selected);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title:
          this.$store.state.userLang == "id"
            ? `Hapus PO: ${tr.noPo}`
            : `Delete PO: ${tr.noPo}`,
        text: this.$t("yakinHapusData"),
        accept: async () => {
          try {
            this.$vs.loading({ text: "Loading..." });
            for (const el of tr.listPodetail) {
              if (el.info == "wo") {
                let getK = await this.$api.get(
                  "api/v1/marketing/kalkulasi/get/" + el.idAsal
                );
                let qtyPurchase = getK.data.qtyPurchase - el.qtyPo;

                await this.$api.put("api/v1/marketing/kalkulasi/" + el.idAsal, {
                  qtyPurchase: qtyPurchase,
                  isHabisPo: qtyPurchase >= getK.data.total ? true : false,
                });

                //cek apakah idwodetail tersebut ada di po
                let cek = await this.$api.get(
                  "api/v1/marketing/kalkulasi/cektopo?idWo=" +
                    getK.data.idWoDetail
                );

                await this.$api.put(
                  "api/v1/ppic/joborderdetail/" + getK.data.idWoDetail,
                  {
                    isUsePo: cek.data.content == true ? true : false,
                  }
                );
              } else if (el.info == "request") {
                let getPo = await this.$api.get(
                  "api/v1/ppic/request/get/" + el.idAsal
                );
                await this.$api.put("api/v1/ppic/request/" + el.idAsal, {
                  qtyPo: getPo.data.qtyPo - el.qtyPo,
                  isApprove: getPo.data.qtyPo - el.qtyPo <= 0 ? false : true,
                  isComplete:
                    getPo.data.qtyPo - el.qtyPo >= getPo.data.qty
                      ? true
                      : false,
                });
              }
              await this.$api.delete("api/v1/purchasing/podetail/" + el.id);
            }
            await this.$api.delete("api/v1/purchasing/poheader/" + tr.id);
            this.$vs.loading.close();
            this.$vs.notify({
              title: this.$t("berhasil"),
              color: "warning",
              text: `${this.$t("delete")} data`,
            });
            this.getData();
          } catch (error) {
            this.$vs.loading.close();
            this.$vs.loading({ text: "error:Hubungi developer" });
            console.log(error);
          }
        },
      });
    },
    async acceptDelete() {
      if (this.selected === null) {
        this.$vs.notify({
          color: "success",
          title: this.$t("berhasil"),
          text:
            this.$store.state.userLang == "id"
              ? "Data berhasil di hapus"
              : "Successfully deleted data",
        });
      } else {
        await this.$api
          .delete(`/api/v1/purchasing/podetail/` + this.selected.id)
          .then((response) => {
            // console.log(response.status);

            this.$vs.notify({
              color: "success",
              title: this.$t("berhasil"),
              text: this.$t("dataBerhasilDihapus"),
            });
            this.getData();
          })
          .catch((error) => {
            console.log(error);
            this.$vs.notify({
              color: "danger",
              title: this.$t("gagal"),
              text:
                this.$store.state.userLang == "id"
                  ? "Data Gagal di hapus"
                  : "Failed to delete data",
            });
            this.errored = true;
          });
      }
    },

    async getData(changeLimit) {
      // console.log("changeLimit");
      try {
        this.loadingTable - true;
        let tglawal = moment(this.tglAwal).format("yyyy-MM-DD");
        let tglakhir = moment(this.tglAkhir).format("yyyy-MM-DD");
        const response = await this.$api.get(
          `api/v1/purchasing/request/rejectlist/findbydate?start=${tglawal}&end=${tglakhir}`
        );

        this.contacts = [];

        response.data.content.forEach((e) => {
          this.contacts.push(e);
        });
        // this.page = response.data.number;
        // this.totalPages = response.data.totalPages;
        this.$vs.loading.close();
      } catch (error) {
        console.log(error);
      }
    },
    berhasilUpdate() {
      this.$vs.notify({
        color: "success",
        title: this.$t("berhasil"),
        text:
          this.$store.state.userLang == "id"
            ? "Data berhasil di perbarui"
            : "Data successfully updated",
      });
    },
  },

  mounted() {
    // console.log("asd". this.search)
    this.tglAkhir = new Date();
    var date = new Date();
    date.setDate(date.getDate() - 30);

    this.tglAwal = date;
    this.getData();
  },
};
</script>

<style lang="css">
hr.new1 {
  border-top: 1px solid grey;
}

#footer {
  position: fixed;
  height: 50px;
  background-color: red;
  bottom: 0px;
  /* left: 0px; */
  right: 0px;
  margin-bottom: 80px;
  z-index: 999999999999;
}

body {
  margin-bottom: 50px;
}
</style>
